var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showContainer
      ? _c(
          "div",
          { staticClass: "callout-container", class: _vm.currentClasses },
          [_vm._t("default")],
          2
        )
      : _vm._e(),
    _vm.showEdition
      ? _c("div", { staticClass: "callout-edition" }, [
          _c(
            "div",
            { class: { "callout-edition-body": _vm.hasEditionBgWhite } },
            [_vm._t("edition")],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }